import { createSelector } from 'reselect';

import gridEntryHelper from '../helpers/data-parsing/gridEntryHelper';
import priceColourCoder from '../helpers/presentation/priceColourCoder';

import type { Direction, MonthDataState, State } from './types';
import type { Overrides } from '../helpers/data-parsing/gridEntryHelper';

const getMonthData = (state: MonthDataState) => state.monthDataGrid;

const getGridPriceData = (
  state: State,
  date: Date,
  direction: Direction,
  overrides: Overrides,
) => gridEntryHelper.getGridPriceData(state, date, direction, overrides);

const hasDirectsForDate = (
  state: State,
  date: Date,
  direction: Direction,
  overrides: Overrides,
) => gridEntryHelper.hasDirectsForDate(state, date, direction, overrides);

const getPriceColourClass = (state: MonthDataState, price: number | null) =>
  priceColourCoder.getColourClass(state.priceColourBands, price);

const hasDirectFlight = createSelector(getMonthData, (monthDataGrid) =>
  gridEntryHelper.hasDirectFlight(monthDataGrid),
);

const isLoading = (state: MonthDataState) => state.isLoading;

const getMonthDataUrl = (state: MonthDataState) => state.monthDataUrl;

const getPriceTrace = (state: MonthDataState, key: string | number) => {
  const traces = state.priceTraces;
  if (!traces) return null;
  return traces[key];
};

export default {
  getGridPriceData,
  getMonthData,
  getPriceColourClass,
  hasDirectsForDate,
  isLoading,
  hasDirectFlight,
  getMonthDataUrl,
  getPriceTrace,
};
